import { memo, ReactNode } from "react";
import { Box, useTheme } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

interface BoardLayoutProps {
  loading: boolean;
  zoomLevel: number;
  showConfig: boolean;
  configPanel: ReactNode;
  children: ReactNode;
}

const BoardLayout = memo(function BoardLayout({
  loading,
  zoomLevel,
  showConfig,
  configPanel,
  children,
}: BoardLayoutProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        overflow: "auto",
        height: "100%",
        backgroundColor:
          theme.palette.mode === "light" ? "#f5f5f5" : "#1e1e1e",
      }}
    >
      <Box sx={{ display: "flex", gap: 2, minHeight: "100%", padding: 2 }}>
        {showConfig ? (
          configPanel
        ) : loading ? (
          <LinearProgress />
        ) : (
          <Box
            sx={{
              display: "flex",
              gap: zoomLevel,
              width: "100%",
              minHeight: "100%",
              alignItems: "stretch",
            }}
          >
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );
});

export default BoardLayout;
